<template>
  <main-layout>
    <div>
      <new-priorities-dialog v-model="isNewPrioritiesDialogOpened" :maker="newClient" @ended="prioritiesCreated" />
      <new-domains-dialog v-model="isNewDomainsDialogOpened" :maker="newClient" @ended="domainsCreated" />
      <new-client-type-dialog
        v-model="isNewClientTypeDialogOpened"
        @choosen="clientTypeChoosen"
      />
      <new-client-dialog
        v-model="isNewClientDialogOpened"
        :is-maker="newClientType === `maker`"
        :loading="isCreatingClient"
        @create="createClient"
      />
      <client-users-dialog
        v-model="isClientUsersOpened"
        :client="clientForClientUsersDialog"
      />
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Clients</span>
        <div class="pl-1" v-if="!isFetchingClients">({{ clients.length }})</div>
        <v-spacer></v-spacer>
        <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewClientTypeDialogOpened = true)">
          <v-icon left>add</v-icon>
          Nouveau client
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <v-row no-gutters justify="center" align="center" class="mb-4">
          <v-col class="py-2search-bar border-component">
            <v-text-field
              v-model="searchString"
              outlined
              dense
              placeholder="Rechercher un client..."
              prepend-inner-icon="search"
              hide-details
              clearable
            />
          </v-col>
          <div class="pl-4">
            <v-row no-gutters justify="center" align="center">
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <div class="ml-2 primary--text font-weight-bold">
                {{ currentPage + 1 }} / {{ nbPages }}
              </div>
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-row>
          </div>
        </v-row>
        <v-list class="pa-0 border-component">
          <v-row no-gutters justify="center" align="center" class="py-8" style="min-height: 100px;" v-if="isFetchingClients">
            <div style="width: 250px;">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
          </v-row>
          <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;" v-else-if="!clients.length">
            Aucun client
          </v-row>
          <template v-else>
            <template v-for="(client, index) in filteredClientsPaginated">
              <v-list-item
                :key="`user-${index}`"
                cclick="openUserDialog(user)"
              >
                <v-list-item-avatar>
                  <v-icon>business</v-icon>
                </v-list-item-avatar>

                <v-row align="center" no-gutters>
                  <v-col align="left">
                    <v-list-item-content>
                      <v-list-item-title>{{ client.name }}</v-list-item-title>
                      <v-list-item-subtitle v-if="client.$slugUrl">
                        <a :href="client.$slugUrl" style="text-decoration: none; color: inherit;">
                          {{ client.$slugUrlWithoutProtocol }}
                        </a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-col>
                  <div>
                    <v-chip small color="orange lighten-1" text-color="white" class="ml-3" v-if="client.isMaker">Prestataire</v-chip>
                    <v-chip small color="primary darken-1" text-color="white" class="ml-3" v-if="client.isAggregator">Donneur d'ordres</v-chip>
                    <v-chip small color="light-blue" text-color="white" class="ml-3" v-if="client.isClient">Client</v-chip>
                  </div>
                  <div class="ml-2">
                    <v-icon color="success" v-if="client.isPayer">monetization_on</v-icon>
                    <v-icon color="grey" v-else>money_off</v-icon>
                  </div>
                  <div class="ml-2">
                    <v-menu rounded>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey">more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="clientForClientUsersDialog = client">
                          Se connecter en tant que...
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-row>
              </v-list-item>
              <v-divider
                v-if="index + 1 < filteredClientsPaginated.length"
                :key="index"
              ></v-divider>
            </template>
          </template>
        </v-list>
        <v-row no-gutters justify="center" align="center" class="pt-6">
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <div class="ml-2 primary--text font-weight-bold">
            {{ currentPage + 1 }} / {{ nbPages }}
          </div>
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </main-layout>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import MainLayout from '@/views/indeegoSettings/MainLayout.vue';
import NewClientTypeDialog from '@/components/IndeegoSettings/NewClientTypeDialog.vue';
import NewClientDialog from '@/components/IndeegoSettings/NewClientDialog.vue';
import NewPrioritiesDialog from '@/components/Settings/Makers/NewPrioritiesDialog.vue';
import NewDomainsDialog from '@/components/Settings/Makers/NewDomainsDialog.vue';
import ClientUsersDialog from '@/components/IndeegoSettings/ClientUsersDialog.vue';
// import DeleteStatusDialog from '@/components/Status/DeleteStatusDialog.vue';

const PAGE_SIZE = 25;

export default {
  data: () => ({
    isFetchingClients: false,
    isNewClientTypeDialogOpened: false,
    isNewClientDialogOpened: false,
    isNewPrioritiesDialogOpened: false,
    isNewDomainsDialogOpened: false,
    isCreatingClient: false,
    searchString: ``,
    newClientType: null,
    newClient: null,
    currentPage: 0,
    clientForClientUsersDialog: null,
  }),
  computed: {
    ...mapState(`ui/indeegoSettingsClients`, {
      storeClients: `clients`,
    }),
    filteredClients() {
      let { clients } = this;
      if (_.trim(this.searchString) !== ``) {
        const searchString = _.lowerCase(this.searchString);
        clients = _.filter(clients, client =>
          client.$searchString.indexOf(searchString) !== -1
        );
      }
      return clients;
    },
    clients() {
      return _.chain(this.storeClients)
        .reject({ slug: `admin` })
        .map(client => ({
          ...client,
          $slugUrl: this.$getSlugUrl(client.slug),
          $slugUrlWithoutProtocol: this.$getSlugUrlWithoutProtocol(client.slug),
        }))
        .map(client => ({
          ...client,
          isMaker: client.isRoot,
          isAggregator: !client.isRoot && Boolean(client.slug.length),
          isClient: !client.isRoot && !client.slug.length,
          isPayer: Boolean(client.slug.length),
          $lowerCaseName: _.toLower(client.name),
          $searchString: _.toLower(`
            ${client.name}
            ${client.slug || ``}
            ${client.$slugUrlWithoutProtocol || ``}
            ${client.address || ``}
            ${client.postalCode || ``}
            ${client.city || ``}
          `).replace(/[\r\n]/g, ` `),
        }))
        .sortBy(`$lowerCaseName`)
        .value();
    },
    filteredClientsPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.filteredClients.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    nbPages() {
      return Math.ceil(this.filteredClients.length / PAGE_SIZE);
    },
    isClientUsersOpened: {
      get() { return this.clientForClientUsersDialog !== null; },
      set() { this.clientForClientUsersDialog = null; },
    },
  },
  methods: {
    // getSlugUrl(slug) {
    //   const baseUrl = process.env.VUE_APP_BASE_URL || `https://indeego.fr`;

    //   if (_.trim(slug).length) {
    //     return baseUrl.replace(/(https?:\/\/)(.*)/, `$1${slug}.$2`);
    //   }

    //   return ``;
    // },
    // getSlugUrlWithoutProtocol(slug) {
    //   const url = this.getSlugUrl(slug);

    //   return url.replace(/https?:\/\//, ``);
    // },
    async fetchClients() {
      this.isFetchingClients = true;
      await this.$store.dispatch(`ui/indeegoSettingsClients/fetchClients`);
      this.isFetchingClients = false;
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageIndex < this.filteredClients.length) {
        this.currentPage += 1;
      }
    },
    clientTypeChoosen(type) {
      this.newClientType = type;
      this.isNewClientTypeDialogOpened = false;
      this.isCreatingClient = false;
      this.isNewClientDialogOpened = true;
    },
    async createClient(infos) {
      this.isCreatingClient = true;
      if (this.newClientType === `maker`) {
        this.newClient = await this.$store.dispatch(`model/client/addMaker`, infos);
      } else {
        this.newClient = await this.$store.dispatch(`model/client/addAggregator`, infos);
      }
      this.isNewClientDialogOpened = false;
      this.isCreatingClient = false;
      this.fetchClients();
      // this.isNewClientDialogOpened = true;
    },
    prioritiesCreated() {
      this.isNewPrioritiesDialogOpened = false;
      this.isNewDomainsDialogOpened = true;
    },
    domainsCreated() {
      this.isNewDomainsDialogOpened = false;
      this.newMaker = null;
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Création du prestaire terminée`,
      });
    },
  //   async stateSave() {
  //     await this.$store.dispatch(`showSnackbar`, {
  //       color: `success`,
  //       message: this.selectedStatus && this.selectedStatus.id ? `Statut modifié avec succès` : `Statut créé avec succès`,
  //     });
  //     this.selectedStatus = {};
  //   },
  //   async stateDelete() {
  //     await this.$store.dispatch(`showSnackbar`, {
  //       color: `success`,
  //       message: `Statut supprimé avec succès`,
  //     });
  //     this.selectedStatus = {};
  //   },
  //   resetSelectedStatus() {
  //     this.selectedStatus = {};
  //   },
  },
  beforeMount() {
    this.fetchClients();
  },
  components: {
    MainLayout,
    NewClientTypeDialog,
    NewClientDialog,
    NewPrioritiesDialog,
    NewDomainsDialog,
    ClientUsersDialog,
    // DeleteStatusDialog,
  },
};
</script>

<style lang="scss">
</style>
